document.addEventListener("DOMContentLoaded", () => {
  const CLICK_THRESHOLD = 8;
  const DRAG_THRESHOLD = 30;

  function initSlider(slider) {
    if (slider.dataset.cartUpsellInitialized === "true") return;
    slider.dataset.cartUpsellInitialized = "true";
    const track = slider.querySelector("[data-cart-upsell-track]");
    const links = slider.querySelectorAll("[data-cart-upsell-link]");
    if (!track || links.length === 0) return;

    let startX = 0;
    let startY = 0;
    let scrollLeft = 0;
    let moved = 0;
    let isDragging = false;
    let active = false;

    function onPointerDown(e) {
      if (!track.contains(e.target)) return;
      startX = e.clientX ?? e.touches?.[0]?.clientX ?? 0;
      startY = e.clientY ?? e.touches?.[0]?.clientY ?? 0;
      scrollLeft = track.scrollLeft;
      moved = 0;
      isDragging = false;
      active = true;

      document.addEventListener("pointermove", onPointerMove, {
        passive: false,
      });
      document.addEventListener("touchmove", onPointerMove, { passive: false });
      document.addEventListener("pointerup", onPointerUp);
      document.addEventListener("touchend", onPointerUp);
      document.addEventListener("pointercancel", onPointerUp);
    }

    function onPointerMove(e) {
      if (!active) return;
      const x = e.clientX ?? e.touches?.[0]?.clientX ?? 0;
      const y = e.clientY ?? e.touches?.[0]?.clientY ?? 0;
      const dx = x - startX;
      const dy = y - startY;
      moved = Math.sqrt(dx * dx + dy * dy);

      if (moved >= CLICK_THRESHOLD) isDragging = true;
      if (moved >= DRAG_THRESHOLD) {
        track.scrollLeft = scrollLeft - dx;
        e.preventDefault();
      }
    }

    function onPointerUp() {
      active = false;
      document.removeEventListener("pointermove", onPointerMove);
      document.removeEventListener("touchmove", onPointerMove);
      document.removeEventListener("pointerup", onPointerUp);
      document.removeEventListener("touchend", onPointerUp);
      document.removeEventListener("pointercancel", onPointerUp);
    }

    function onLinkClick(e) {
      if (isDragging || moved >= CLICK_THRESHOLD) {
        e.preventDefault();
        e.stopPropagation();
      }
    }

    function preventImageDrag(e) {
      e.preventDefault();
    }
    track.addEventListener("dragstart", preventImageDrag);
    track.addEventListener("drag", preventImageDrag);
    track.addEventListener("pointerdown", onPointerDown, { passive: true });
    track.addEventListener("touchstart", onPointerDown, { passive: true });
    links.forEach(function (link) {
      link.addEventListener("click", onLinkClick, { capture: true });
    });
  }

  /**
   * Run slider init for every cart upsell slider in scope.
   * Call after any section render (e.g. cart refresh, Section Rendering API, theme editor).
   * @param {Document|Element} [root] - Scope to search; defaults to document.
   */
  function initCartUpsellSliders(root) {
    const scope = root && root.nodeType === 1 ? root : document;
    scope.querySelectorAll("[data-cart-upsell-slider]").forEach(initSlider);
  }

  window.initCartUpsellSliders = initCartUpsellSliders;

  initCartUpsellSliders(document);

  document.addEventListener("cart-drawer:content-refreshed", function () {
    initCartUpsellSliders(document);
  });

  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target && e.target.nodeType === 1 ? e.target : document;
    initCartUpsellSliders(root);
  });
});
